export enum ComparisonOperators {
  Less = 'lt',
  LessOrEqual = 'lte',
  Greater = 'gt',
  GreaterOrEqual = 'gte',
  Equal = 'eq',
  NotEqual = 'ne'
}

const ComparisonOperatorsMap = new Map([
  [ComparisonOperators.Less, '<'],
  [ComparisonOperators.LessOrEqual, '<='],
  [ComparisonOperators.Greater, '>'],
  [ComparisonOperators.GreaterOrEqual, '>='],
  [ComparisonOperators.Equal, '='],
  [ComparisonOperators.NotEqual, '!=']
]);

export const convertComparisonOperatorToSymbol = (op: string) => {
  const typedOp = op as ComparisonOperators;
  if (ComparisonOperatorsMap.has(typedOp)) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return ComparisonOperatorsMap.get(typedOp)!;
  }

  return '';
};
